import React from 'react';
import _get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Slide from '@material-ui/core/Slide';
import { makeSelectTextDirection } from 'containers/Main/selectors';
import { showFloatingHelpfulAgain } from 'containers/Main/actions';
import Mixpanel from 'utils/mixpanelService';
import { ResourcePageHelpfulContent } from './ResourcePageHelpfulContent';

const useStyles = makeStyles(theme => ({
  root: {
    width: 366,
    position: 'fixed',
    left: 20,
    bottom: 72,
    zIndex: 999,
    border: '1px solid #E3E3E3',
    padding: 26,
    boxShadow: '0 2px 14px 0 rgba(0,0,0,0.10)',
    borderRadius: 10,
    [theme.breakpoints.up('1200')]: {
      right: '8%',
    },
    [theme.breakpoints.up('1400')]: {
      right: '10%',
    },
    [theme.breakpoints.down('480')]: {
      bottom: 0,
      right: 0,
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      borderRadius: 0,
      width: '100%',
    },
  },
}));

function ResourcePageHelpful(props) {
  const textDirection = useSelector(makeSelectTextDirection());
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('xs'));
  const classes = useStyles({ textDirection });
  const dispatch = useDispatch();
  const clientDetails = useSelector(state => state.main.clientDetails);
  const helpfulLocation = useSelector(state => state.main.helpfulLocation);

  if (!props.show) return null;

  if (isMobile && _get(clientDetails, 'metadata.hideMobileHelpful'))
    return null;

  const {
    type,
    toggle,
    item: {
      fields: { title, slug, name, article },
      sys: { id },
    },
  } = props;

  const onClose = () => {
    toggle(true);
    Mixpanel.track('Was This Helpful - Dismissed', {
      path: window.location.pathname,
      type,
      name: title || name || article,
      location: helpfulLocation || 'slide-in',
      slug,
      entryId: id,
    });
  };

  const onDontShowAgainClick = () => {
    dispatch(showFloatingHelpfulAgain(false));
    toggle(true);
    Mixpanel.track('Was This Helpful - Skip Clicked', {
      path: window.location.pathname,
      type,
      name: title || name || article,
      location: helpfulLocation || 'slide-in',
      slug,
      entryId: id,
    });
  };

  return (
    <Slide direction="right" in mountOnEnter unmountOnExit>
      <ResourcePageHelpfulContent
        customClasses={classes}
        helpfulLocation={helpfulLocation}
        onClose={onClose}
        onDontShowAgainClick={onDontShowAgainClick}
        {...props}
      />
    </Slide>
  );
}
ResourcePageHelpful.propTypes = {
  show: PropTypes.bool,
  toggle: PropTypes.func,
  ratings: PropTypes.object,
  item: PropTypes.object,
  type: PropTypes.string,
};

export default ResourcePageHelpful;
